import { keys } from '../../query/keyRegistry';

export const menuKeys = {
  day: (customer_id: number, date_ymd: string, is_double_box: boolean) =>
    keys.customer(customer_id).menu(date_ymd, is_double_box),
  all: (customer_id: number) => keys.customer(customer_id).menuAll,
  guestPreview: (date_ymd: string) => ['guest-menu-preview-date', date_ymd] as const,
};
